export enum GalleryContentType {
  USER = 'USER',
  TESS = 'TESS',
}
